'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiFlowParallel = function TiFlowParallel(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 27v-14c1.9-0.7 3.3-2.5 3.3-4.7 0-2.7-2.2-5-5-5s-5 2.3-5 5c0 2.2 1.4 4 3.4 4.7v14c-2 0.7-3.4 2.5-3.4 4.7 0 2.7 2.3 5 5 5s5-2.3 5-5c0-2.2-1.4-4-3.3-4.7z m-1.7-20.3c1 0 1.7 0.7 1.7 1.6s-0.7 1.7-1.7 1.7-1.6-0.7-1.6-1.7 0.7-1.6 1.6-1.6z m0 26.6c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.7 1.6-1.7 1.7 0.7 1.7 1.7-0.7 1.6-1.7 1.6z m-11.6-25c0-2.7-2.3-5-5-5s-5 2.3-5 5c0 2.2 1.4 4 3.3 4.7v14c-1.9 0.7-3.3 2.5-3.3 4.7 0 2.7 2.2 5 5 5s5-2.3 5-5c0-2.2-1.4-4-3.4-4.7v-14c2-0.7 3.4-2.5 3.4-4.7z m-5-1.6c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.7-1.6 1.7-1.7-0.7-1.7-1.7 0.7-1.6 1.7-1.6z m0 26.6c-1 0-1.7-0.7-1.7-1.6s0.7-1.7 1.7-1.7 1.6 0.7 1.6 1.7-0.7 1.6-1.6 1.6z' })
        )
    );
};

exports.default = TiFlowParallel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/flow-parallel.js
// module id = 3633
// module chunks = 0